module.exports = __webpack_public_path__ + "img/mobil.fee110ee.jpg";